<div class="row">
    <div class="col-sm-12 text-end">
        <a routerLink="../add" class="btn-add">
            <i class="fa fa-plus px-2"></i> Agregar
        </a>
    </div>
</div>
<div class="row">
    <div class="container my-1">
        <div class="filter-bar row g-1 p-3">
            <!-- Campo de búsqueda -->
            <div class="col-12 col-md-6">
                <input type="text" [(ngModel)]="filters.searchText" placeholder="Buscar por nombre o usuario"
                    (input)="applyFilter()" class="form-control filter-input" />
            </div>
            <!-- Filtro por roles -->
            <div class="col-12 col-md-3">
                <select [(ngModel)]="filters.role" (change)="applyFilter()" class="form-select filter-select">
                    <option value="">Todos los roles</option>
                    <option *ngFor="let role of availableRoles" [value]="role">
                        {{ role }}
                    </option>
                </select>
            </div>
            <!-- Filtro por estado -->
            <div class="col-12 col-md-3">
                <select [(ngModel)]="filters.status" (change)="applyFilter()" class="form-select filter-select">
                    <option [ngValue]="null">Todos los estados</option>
                    <option [ngValue]="true">Activo</option>
                    <option [ngValue]="false">Inactivo</option>
                </select>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="table-responsive">
        <table class="table table-hover">
            <thead class="thead-detail text-center table-success">
                <tr>
                    <th scope="col">N°</th>
                    <th scope="col">Nombre y apellido</th>
                    <th scope="col">Usuario</th>
                    <th scope="col">rol</th>
                    <th scope="col">Permisos</th>
                    <th scope="col">Activo</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let user of filteredUsers; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{user.person.name +' '+ user.person.lastname }}</td>
                    <td><a class="link-detail">{{ user.email }}</a></td>
                    <td *ngIf="user.roles[0] == undefined">
                        Sin asignar
                    </td>
                    <td *ngIf="user.roles[0] !== undefined">
                        {{user.roles[0].label}}
                    </td>
                    <td>
                        <a [routerLink]="['/adm/usuarios/listAccess', user.id]" class="btn-add"
                            title="Editar permisos de usuario">
                            <i class="fa fa-list-ol px-2"></i> ver
                        </a>
                    </td>
                    <td>
                        <div class="label-active text-center" *ngIf="user.isActive">ACTIVO</div>
                        <div class="label-inactive text-center" *ngIf="!user.isActive">INACTIVO</div>
                    </td>
                    <td><a class="a-icon text-center" title="Editar información usuario"
                            [routerLink]="['/adm/usuarios/edit', user.id]"><i class="fa fa-pencil i-icon"></i></a></td>
                    <td>
                        <a *ngIf="user.isActive" class="a-icon text-center" title="Quitar acceso"
                            (click)="deleteUserAccess(user.id,user.person.lastname)"><i
                                class="fa fa-trash i-icon"></i></a>
                        <a *ngIf="!user.isActive" class="a-icon text-center" title="Activar acceso"
                            (click)="grantedUserAccess(user.id,user.person.lastname)"><i
                                class="fa fa-retweet i-icon"></i></a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>